import { render } from "./NewSaving.vue?vue&type=template&id=eab4b1cc&scoped=true"
import script from "./NewSaving.vue?vue&type=script&lang=js"
export * from "./NewSaving.vue?vue&type=script&lang=js"

import "./NewSaving.vue?vue&type=style&index=0&id=eab4b1cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eab4b1cc"

export default script